import { ApiResponseCode } from './api-response-codes.enum';

export class LoyaltyResponse<T> {
  public soloResponseCode: ApiResponseCode;
  public loyaltyResponseCode: number;
  public responseMessage: string;
  public value: T;
}
